import { counter } from "./components";

function get_random_int(min: number, max: number) {
  const minCeiled = Math.ceil(min);
  const maxFloored = Math.floor(max);
  return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
}

let count_to = get_random_int(5, 20);
let count_value = 0;

export function activate_counter() {
  if (counter) {
    counter.textContent = count_value.toString();
  }
  count_value++;
  if (count_value == count_to) {
    count_value = 0;
    count_to = get_random_int(5, 20);
    console.debug(`counting until: ${count_to}`);
  }
  setTimeout(activate_counter, 1000);
}
